import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Select,
  Switch,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { useSnapSiteConfigEditContext } from '@ui/features/snap-site-config/screens/edit/context/hook';
import { get, useFormContext } from 'react-hook-form';

export function FixedMarketForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();
  const { marketCodes } = useSnapSiteConfigEditContext();

  const marketCodeFieldPath = fieldPath('marketCode');
  const marketCodeFieldError = get(form.formState.errors, marketCodeFieldPath);
  const allowFallbackFieldPath = fieldPath('allowFallback');

  return (
    <>
      <FormControl isInvalid={!!marketCodeFieldError} isRequired>
        <FormLabel htmlFor={marketCodeFieldPath}>Market Code:</FormLabel>

        <Select
          {...form.register(marketCodeFieldPath)}
          id={marketCodeFieldPath}
        >
          {marketCodes.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </Select>

        <ErrorMessage
          name={marketCodeFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl>
        <Flex alignItems="center" gap={2} mb={1}>
          <Switch
            id={allowFallbackFieldPath}
            {...form.register(allowFallbackFieldPath)}
          />
          <FormLabel htmlFor={allowFallbackFieldPath} mb={0}>
            Allow Fallback
          </FormLabel>
        </Flex>
        <FormHelperText>
          When enabled, passes down to the next price strategy if quantity
          exceeds this strategy's maximum quantity break.
        </FormHelperText>
      </FormControl>
    </>
  );
}
